<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

const UpsellRealRecipes = () =>
  import("@/components/upsell/UpsellRealRecipes.vue");

export default {
  name: "Upsell",
  page: {
    title: "Thank You for Your Purchase",
    meta: [{ name: "description", content: "Thank You Page." }],
  },
  components: {
    Header,
    Footer,
    UpsellRealRecipes,
  },
  props: {
    upsellCombo: { type: String, default: "UpsellRealRecipes" },
    isUpgrade: { type: Boolean, default: false },
    hasSubscription: { type: Boolean, default: false },
  },
  data() {
    return {
      content: null,
      customerInfo: null,
    };
  },
  computed: {
    upsellComponent() {
      return this.upsellCombo;
    },
  },
  mounted: function () {
    console.log(
      "Upsell: " +
        this.upsellComponent +
        " isUpgrade? " +
        this.isUpgrade +
        " hasSubscription: " +
        this.hasSubscription
    );
  },
  methods: {},
};
</script>
<template>
  <main class="oto-main">
    <div class="container text-center content-thank">
      <component
        :is="upsellComponent"
        :isUpgrade="isUpgrade"
        :hasSubscription="hasSubscription"
        id="upsell-card"
      />
    </div>
    <Footer />
  </main>
</template>
<style lang="scss">
html,
body,
#app {
  height: 100%;
  overflow-x: hidden;
}
.oto-main {
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  .logo img {
    max-width: 236px;
    width: 100%;
  }
}
.container {
  .row {
    min-height: 175px;
  }
  h1 {
    font-size: 36px;
    color: #000000;
    font-weight: 700;
    margin-top: 20px;
    text-transform: uppercase;
  }
  h2 {
    color: #000000;
    font-size: 22px;
    line-height: 34px;
    margin-top: 30px;
    span {
      color: #499f30;
      text-transform: capitalize;
    }
  }
}
.content-thank {
  padding: 2% 0;
}
.navbar-global-header {
  font-size: 16px;
  padding: 0 !important;
  justify-content: flex-end !important;
  li {
    align-self: center;
  }
  a {
    color: #000000 !important;
    line-height: 42px;
    padding: 0 25px !important;
    &:hover {
      color: #79b867 !important;
    }
  }
}
.tryfree a {
  background: #79b867;
  border: 2px solid #79b867;
  border-radius: 30px;
  color: #ffffff !important;
  font-weight: 700;
  line-height: 42px;
  margin: 0 15px;
  padding: 0 40px !important;
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff !important;
  }
}
.ds-action-button {
  background: #79b867;
  border: 1px solid #79b867;
  border-radius: 50px;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 53px;
  padding: 0 15px;
  margin: 1.5rem 0rem;
  text-transform: uppercase;
  min-width: 30ch;
  max-width: 100ch;
  .spinner-border {
    vertical-align: middle;
  }
  &:hover {
    background: #000000;
    border-color: #000000;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}
.ds-action-button-main {
  background: #e00b11;
  border: 1px solid #e00b11;
  &:hover {
    background: #79b867;
    border-color: #79b867;
    color: #ffffff;
  }
  &:focus {
    outline: none;
  }
}

@media (min-width: 992px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg {
    .row {
      max-width: 1230px !important;
    }
  }
}
@media screen and (max-width: 1139px) {
  .container {
    .row {
      min-height: 110px;
    }
    h1 {
      font-size: 24px;
    }
    h2 {
      font-size: 18px;
    }
  }
  .hide-small {
    display: none;
  }
}
@media screen and (min-width: 1140px) {
  .hide-lg {
    display: none;
  }
}
@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    .row {
      max-width: 1230px !important;
    }
  }
}
</style>